module.exports = __webpack_public_path__ + "img/talent-logo-default-monochrome.3878c441.svg";